import { getEndpoint, getHeaders, getMPPEndpoint } from '../../../../helpers/endpoint';
import swal from 'sweetalert2';

export const postImageUpload = (
    file: File,
    onSuccess: (imageUrl: string) => void,
  ) => {
    const formData = new FormData();
    formData.append('file', file);
    return (_dispatch, getState) => {
      fetch(getEndpoint('postImageUpload'), {
        method: 'POST',
        headers: {Authorization: getState().authentication.token},
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            swal({
              title: `Oops...`,
              type: 'error',
              html: `Something went wrong with: "${data.error}"<br/>`,
            });
          } else {
            onSuccess(data.url);
          }
        })
        .catch(error => {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong with: "${error}"<br/>`,
          });
        });
    };
  };

  export const createMPPChallenge = (
    payload,
    onSuccess,
    onError
  ) => {
    return (_dispatch, getState) => {
      fetch(getMPPEndpoint('createMPPChallenge'), {
        method: 'POST',
        headers: getHeaders(getState().authentication),
        body: JSON.stringify(payload),
      })
      .then(response => response.json())
      .then((data) => {
        if (data[0]?.errors) {
          alert(`error: ${JSON.stringify(data[0]?.errors?.issues)}`)
        } else {
          onSuccess()
        }
      })
    }
  };

  export const updateMPPChallenge = (
    payload,
    editedChallengeId,
    onSuccess,
    onError
  ) => {
    return (_dispatch, getState) => {
      fetch(getMPPEndpoint('updateMPPChallenge', editedChallengeId), {
        method: 'PATCH',
        headers: getHeaders(getState().authentication),
        body: JSON.stringify(payload),
      }).then(() => {
        onSuccess()
      }).catch(() => {
        onError()
      })
    }
  };

  export const getMPPChallenge = (selectedLanguage, payload, onSuccess, onError) => {
    return (__, getState) => {
      fetch(getMPPEndpoint('fetchMPPLeague', payload), {
        method: 'GET',
        headers: getHeaders(getState().authentication),
      })
        .then(response => response.json())
        .then(response => {
          if (response.error)
            return onError(response.error)
          else {
            onSuccess({
                championshipId: response.gameSettings.championshipId,
                firstGameWeekNumber: response.gameSettings.firstGameWeekNumber,
                lastGameWeekNumber: response.gameSettings.lastGameWeekNumber,
                bonuses: response?.gameSettings?.bonuses,
                isSupervised: response?.isSupervised || false,
                isPinned: response?.isPinned || false,
                isSuperPinned: true,
                customShortChallengeId: payload.contestId,
                localization: {
                  [selectedLanguage]: {
                    name: response.name,
                    description: response.description,
                    supervisedDescription: response?.supervisedDescription,
                    backgroundImageUrl: response?.backgroundImageUrl,
                    imageUrl: response.imageUrl,
                    presentationImageUrl: response?.presentationImageUrl,
                  }
                }
              })
          }
        })
        .catch((error) => {
          return onError(error)
        });
    };
  };


// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPCreateChallengeEditor/api.ts